<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="NADL-1"><span class="ePub-I">November 6, 1937</span></p>
<p class="NADL"><span class="ePub-I">Los Angeles Register</span></p>
<p class="NAH-1"><span class="ePub-B">‘ALLEY ANGEL’ SLAIN IN HOLLYWOOD</span></p>
<p class="NASH"><span class="ePub-B">Mystery Woman in Fashion Finery</span></p>
<p class="NAT"><span class="nat">LOS ANGELES, NOV. 5 (AP)</span> - The body of an unidentified woman was found in an alley behind a butcher shop in Hollywood today. The woman had been shot several times, according to police sources. More baffling to authorities, the woman was dressed in attire more suited to a movie colony premiere than the humble environs where she was discovered.</p>
<p class="NATI">The body, draped in a silk gown and numerous shimmering stones, was found in the early hours of November 5 by an employee of the shop. “She looked like an angel,” said Spyros Makadoulis, age 41. “Like she’d fallen from heaven itself.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?8d8ea1d6